import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
    LayoutDashboard,
    Layers,
    Users,
    HelpCircle,
    Briefcase,
    Lightbulb,
    School,
    Video,
    FileText,
    MessageSquare,
    GraduationCap,
    MessageSquarePlus
} from "lucide-react";
import "./AdminLayout.css";

const AdminSidebar = ({ user }) => {
    const location = useLocation();
    const path = location.pathname;

    const isActive = (targetPath) => path === targetPath;

    const dashboardItems = [
        { name: "Admin", path: "/admin/dashboard", icon: LayoutDashboard },
        { name: "Course Creator", path: "/admin/content-creator", icon: Layers },
        { name: "Instructor", path: "/admin/instructor", icon: GraduationCap, badge: 3 },
    ];

    const quickLinks = [
        { name: "All schools", path: "/admin/schools", icon: School },
        { name: "All courses", path: "/admin/courses-new", icon: FileText },
        { name: "All users", path: "/admin/users", icon: Users },
        { name: "Queries", path: "/admin/queries", icon: MessageSquarePlus, badge: 17 },
    ];

    return (
        <aside className="admin-sidebar">
            <div className="admin-s-lbl">Dashboards</div>
            {dashboardItems.map((item) => (
                <Link
                    key={item.path}
                    to={item.path}
                    className={`admin-s-item ${isActive(item.path) ? "active" : ""}`}
                >
                    <div className="admin-s-ic">
                        <item.icon size={13} strokeWidth={1.5} />
                    </div>
                    {item.name}
                    {item.badge && <span className="admin-s-badge">{item.badge}</span>}
                </Link>
            ))}

            <div className="admin-s-lbl">Quick links</div>
            {quickLinks.map((item) => (
                <Link
                    key={item.path}
                    to={item.path}
                    className={`admin-s-item ${isActive(item.path) ? "active" : ""}`}
                >
                    <div className="admin-s-ic">
                        <item.icon size={13} strokeWidth={1.5} />
                    </div>
                    {item.name}
                    {item.badge && <span className="admin-s-badge">{item.badge}</span>}
                </Link>
            ))}

            <div className="admin-s-foot">
                <div className="admin-s-role">Signed in as</div>
                <div className="admin-s-role-name">
                    {user?.nickname || user?.name || "Admin"} · Super Admin
                </div>
            </div>
        </aside>
    );
};

export default AdminSidebar;
